module.exports = __webpack_public_path__ + "img/shipo-popup-icon-terminate.f3ff2110.svg";